import api from './api.js';
import formset from '../versa/formset.js';
import login_form from '../versa/forms/login.js';
import pwdreq_form from '../versa/forms/pwdreq.js';
import { notify, ask } from '../versa/msgbox.js';

const handler = function(key)
{
	switch (key)
	{
		case 'Link':
			auth.request();
			break;
	}
}

const auth = {

	login(callback)
	{
		let fs = formset.create(login_form, async (data) =>
		{
			if (await api.call(api.auth, data.username, data.password))
			{
				sessionStorage.username = data.username;
				fs.destroy();
				callback?.();
			}
		}, handler);
		fs.init();
	},

	logout()
	{
		ask('Deseja sair?', 'Confirmação', async (answer) =>
		{
			if (answer == 'Y')
			{
				delete sessionStorage.username;
				location.reload();
			}
		});
	},

	request()
	{
		let fs = formset.create(pwdreq_form, async (data) => 
		{
			if (await api.call(api.request_password, data))
			{
				fs.destroy();
				notify('Verifique o link recebido', 'Sucesso');
			}
		});
		fs.init();
	}

};

export default auth;

